import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { connect } from 'react-redux'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import { userActions } from '../../redux/actions'
import { userService } from '../../services'

const ResendPhoneCode = ({ user, className }) => {
  const [sending, setSending] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const resendPhoneCode = () => {
    setSending(true)
    userService
      .resendVerifyPhoneCode()
      .then(() => setShowModal(true))
      .finally(() => setSending(false))
  }

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  // Unique IDs for accessibility
  const modalId = 'phone-verification-modal'
  const modalTitleId = 'phone-verification-title'

  return (
    <div className="phone-verification-container">
      <div className="my-3">
        {sending ? (
          <span aria-live="polite">
            <FormattedMessage id="global.label.sending" />
            ...
          </span>
        ) : (
          <button
            type="button"
            className="btn btn-link p-0 text-left"
            onClick={resendPhoneCode}
            aria-label="Resend phone verification code"
          >
            <FormattedMessage id="global.label.resendPhoneCode" />
          </button>
        )}
      </div>

      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        className={className}
        size="lg"
        id={modalId}
        aria-labelledby={modalTitleId}
        role="dialog"
      >
        <ModalHeader toggle={toggleModal}>
          <span className="sr-only">
            <FormattedMessage id="global.label.close" defaultMessage="Close" />
          </span>
        </ModalHeader>
        <ModalBody>
          <h2 id={modalTitleId} className="text-center">
            <FormattedMessage id="page.activationPage.phoneActivationSent.title" />
          </h2>
          <p>
            <FormattedMessage
              id="page.activationPage.phoneActivationSent.description"
              values={{ phone: user.phone }}
            />
          </p>
        </ModalBody>
        <ModalFooter>
          <div className="w-100">
            <div className="row">
              <div className="col">
                <Button
                  block
                  outline
                  color="light"
                  onClick={toggleModal}
                  aria-label="Close this message"
                >
                  OK
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
}

ResendPhoneCode.propTypes = {
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
}

ResendPhoneCode.defaultProps = {
  className: '',
}

const { resendVerifyPhoneCode } = userActions
const ConnectedComponent = connect(null, { resendVerifyPhoneCode })(ResendPhoneCode)

export default ConnectedComponent
